// extracted by mini-css-extract-plugin
module.exports = {"price":"_7a3fb80146--price--GVJrq","heading":"_7a3fb80146--heading--pNoJI","relevance":"_7a3fb80146--relevance--N9p5j"};